import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import NavBottom from './navBottom/NavBottom';
import NavTop from './navTop/NavTop';

const Wrapper = styled.div``;

function Navigation({ setShowSearch }) {
  const customerOverlayNav = useSelector(
    state => state.Global.customerOverlayNav
  );
  return (
    <Wrapper>
      <CustomerOverlay
        className={`customer-overlay-nav ${
          customerOverlayNav ? 'overlay-on' : ''
        }`}
      />
      <NavTop setShowSearch={setShowSearch} />
      <NavBottom />
    </Wrapper>
  );
}

export default Navigation;

const CustomerOverlay = styled.div`
  background: rgba(0, 0, 0, 0.75);
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: fixed;
  right: 0;
  top: 0;
  transition: opacity 0.8s ease-out;
  z-index: 1001;

  &.overlay-on {
    opacity: 1;
    transition: opacity 0.3s ease-out;
  }
`;
